<ng-container *transloco="let t">
  <div class="flex flex-col gap-2">
    <!-- Label -->
    @if (props.label) {
      <p class="font-semibold">
        {{ props.label }}
        <span *ngIf="props.required" class="text-red-500">*</span>
      </p>
    }

    <!-- Single Selection Dropdown -->
    @if (!isMultiselect) {
      <p-select
        [formControl]="formControl"
        [options]="selectOptions"
        [placeholder]="props.placeholder || t('app.formly-types.dropdown.singleSelectionPlaceholder')"
        [showClear]="!props.required"
        [panelStyle]="{ width: '100%' }"
        (onChange)="formControl.markAsDirty()"
        [styleClass]="formControl.invalid && (formControl.dirty || formControl.touched) ? 'border-red-500' : ''"
        [ngClass]="{ 'p-disabled': formControl.disabled }"
        [filter]="props['searchable'] ? true : false"
        appendTo="body"
        [baseZIndex]="1000"
      ></p-select>
    }

    <!-- Multi Selection Dropdown -->
    <!-- maxSelectedLabels only affect how many chips are showing in the field, and doesn't affect the return value -->
    @if (isMultiselect) {
      <p-multiSelect
        [formControl]="formControl"
        [options]="selectOptions"
        [placeholder]="props.placeholder || t('app.formly-types.dropdown.multiSelectionPlaceholder')"
        [panelStyle]="{ width: '100%' }"
        (onChange)="formControl.markAsDirty()"
        [styleClass]="formControl.invalid && (formControl.dirty || formControl.touched) ? 'border-red-500' : ''"
        [showToggleAll]="true"
        [maxSelectedLabels]="props['maxSelectedLabels'] ?? 20"
        [selectedItemsLabel]="t('app.formly-types.select.selectedItemsLabel')"
        optionLabel="label"
        [display]="props['displayType'] === 'comma' ? 'comma' : 'chip'"
        optionValue="value"
        appendTo="body"
        [baseZIndex]="1000"
      ></p-multiSelect>
    }

    <!-- Validation Message -->
    @if (formControl.invalid && (formControl.dirty || formControl.touched)) {
      <p class="text-sm text-red-500">
        {{ errorMessage }}
      </p>
    }

    <!-- Description -->
    @if (props.description) {
      <div class="text-sm text-surface-600 dark:text-surface-400">
        {{ props.description }}
      </div>
    }
  </div>
</ng-container>
